<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>其他</el-breadcrumb-item>
      <el-breadcrumb-item>自定义配置</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <el-tabs v-model="activeName">
        <el-tab-pane label="派工员区域设置" name="first"
          ><DispatcherSetting></DispatcherSetting
        ></el-tab-pane>
        <el-tab-pane label="评估阶段超时配置" name="second"
          ><ServiceQuestWaitDay :type="3"></ServiceQuestWaitDay
        ></el-tab-pane>
        <el-tab-pane label="审批阶段超时配置" name="third"
          ><ServiceQuestWaitDay :type="4"></ServiceQuestWaitDay
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ServiceQuestWaitDay from '../../views/custom_config/ServiceQuestWaitDay.vue'
import DispatcherSetting from './DispatcherSetting.vue'
export default {
  components: {
    ServiceQuestWaitDay,
    DispatcherSetting,
  },
  data() {
    return {
      activeName: 'first',
    }
  },
}
</script>
